'use strict';

var ConfigurationBudgetTargetDirective = function ConfigurationBudgetTargetDirective() {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/configurationBudgetTarget.html'),
    controller: 'ConfigurationBudgetTargetController',
    link: function link(scope) {
      scope.$on('configuration-budget-target:saveChanges', scope.saveChanges);
      scope.$on('configuration-budget-target:loadedSuccessful', scope.loadedSuccessful);
      scope.$on('configuration-budget-target:removeBudgetTarget', scope.removeBudgetTarget);
    }
  };
};
ConfigurationBudgetTargetDirective.$inject = [];
module.exports = ConfigurationBudgetTargetDirective;